import type { ValueOf } from "@p-ban/common/src/types"

const MOUNT_COURSE = {
  mount: { key: "mount", name: "実装", value: "1", option: true },
  mountExpress: { key: "mountExpress", name: "実装短納期", value: "2", option: false },
} as const

export default MOUNT_COURSE

export type MountCourse = ValueOf<typeof MOUNT_COURSE>

export const getManufactureMountByValue = (value: string): MountCourse => {
  const mount = Object.values(MOUNT_COURSE).find((nameValue) => nameValue.value === value)
  if (mount === undefined) {
    throw new Error(`実装サービスの取得に失敗しました。value: ${value}`)
  }
  return mount
}
